<template>
    <v-container fluid>
		<v-snackbar
			v-model="snackbar" top vertical="" :timeout="4000"
			>
			{{ Mensaje }}
			<v-btn
			color="pink"
			text
			@click="snackbar = false"
			>
			Cerrar
			</v-btn>
		</v-snackbar>
		<v-dialog
		v-model="dialog"
		persistent
		width="1024"
		>
		<v-card>
			<v-card-title>
			<span class="text-h5">Creación de cuenta bancaria</span>
			</v-card-title>
			<v-card-text>
			<v-container>
				<v-row>
				<v-col
					cols="12"
					sm="6"
					md="4"
				>
					<v-text-field
					label="Alias*"
					required
					filled
					hint="Nombre para reconocer la cuenta"
					v-model="alias"
					></v-text-field>
				</v-col>
				<v-col
					cols="12"
					sm="6"
					md="4"
				>
					<v-text-field
					label="Cuenta IBAN"
					filled
					v-model="cuenta"
					hint="recomendamos usar su cuenta iban"
					></v-text-field>
				</v-col>
				<v-col
					cols="12"
					sm="6"
					md="4"
				>
					<v-select
					:items="['CRC', 'USD', 'EUR', 'GTQ']"
					label="Moneda*"
					filled
					hint="Moneda en la cual se realizan las transacciones"
					persistent-hint
					v-model="moneda"
					required
					></v-select>
				</v-col>
				<v-col
					cols="12"
					sm="3"
				>
				<v-text-field
					label="Retención"
					required
					onfocus="this.select();"
					prefix="%"
					persistent-hint
					v-model="retencion"
					hint="Digite el porcentaje de retención del datofono o cada ingreso de dinero que se haga en esta cuenta"
					type="number"
					filled
					></v-text-field>
					
				</v-col>
				<v-col
					cols="12"
					sm="3"
				>
				<v-text-field
					label="Saldo inicial"
					required
					persistent-hint
					onfocus="this.select();"
					v-model="saldoinicial"
					hint="Saldo inicial que tendrá la cuenta en la moneda seleccionada"
					type="number"
					filled
					></v-text-field>
					
				</v-col>
				<v-col
					cols="12"
					sm="6"
				>
				<v-text-field
					label="Nota o Comentario"
					v-model="detalle"
					filled
					></v-text-field>
					
				</v-col>
				</v-row>
			</v-container>
			<small>*Indica campo requerido</small>
			</v-card-text>
			<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="error"
				variant="text"
				@click="dialog = false"
			>
				Cerrar
			</v-btn>
			<v-btn
				color="primary"
				variant="text"
				@click="CrearCuenta()"
				:loading="loading"
			>
				Guardar
			</v-btn>
			</v-card-actions>
		</v-card>
		</v-dialog>
		
		<v-dialog
		v-model="dialogDeposito"
		persistent
		width="1024"
		>
			<v-card>
				<v-card-title>
				<span class="text-h5">Deposito de dinero a cuenta</span>
				</v-card-title>
				<v-card-text>
				<v-container>
					<v-row>
					<v-col
						cols="12"
						sm="6"
						md="6"
					>
						<v-select
						label="Cuenta"
						filled
						:items="Cuentas"
						v-model="cuenta"
						></v-select>
					</v-col>
					<v-col
						cols="12"
						sm="6"
					>
					<v-text-field
						label="Monto"
						required
						persistent-hint
						onfocus="this.select();"
						v-model="saldoinicial"
						hint="Monto a depositar que tendrá la cuenta en la moneda seleccionada"
						type="number"
						filled
						></v-text-field>
					</v-col>
					<v-col
						cols="12"
						sm="3"
						md="3"
					>
						<v-select
						label="Tipo Pago"
						filled
						:items="TipoPagos"
						v-model="tipoPago"
						></v-select>
					</v-col>
					<v-col
						cols="12"
						sm="3"
						md="3"
					>
						<v-select
						:items="['CRC', 'USD', 'EUR', 'GTQ']"
						label="Moneda*"
						filled
						hint="Moneda en la cual se realizan las transacciones"
						persistent-hint
						v-model="moneda"
						required
						></v-select>
					</v-col>
					<v-col
						cols="12"
						sm="6"
					>
					<v-text-field
						label="Nota o Comentario"
						v-model="detalle"
						filled
						></v-text-field>
						
					</v-col>
					</v-row>
				</v-container>
				<small>*Depositos se realizará en moneda destino,depositos en tarjeta aplica retención en caso de tenerla asignada</small>
				</v-card-text>
				<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="error"
					variant="text"
					@click="dialogDeposito = false"
				>
					Cerrar
				</v-btn>
				<v-btn
					color="primary"
					variant="text"
					@click="Deposito()"
					:loading="loading"
				>
					Guardar
				</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-app-bar color="boton" app>
			<v-toolbar-title>
			<v-btn style="color: white;" text> Transferencia </v-btn>
			</v-toolbar-title>
			<v-toolbar-title class="mx-2">
			<v-btn style="color: white;" @click="dialogDeposito = true" text> Deposito </v-btn>
			</v-toolbar-title>
			<v-toolbar-title class="mx-2">
			<v-btn style="color: white;" @click="dialog = true" text> Crear Cuenta </v-btn>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-menu offset-y>
			<template v-slot:activator="{ on }">
				<v-btn color="white" icon v-on="on">
				<v-icon>mdi-dots-vertical</v-icon>
				</v-btn>
			</template>
			<v-list>
				<v-list-item v-for="link in links" :key="link.id" :to="link.path">
				<v-list-item-title>{{ link.name }}</v-list-item-title>
				</v-list-item>
			</v-list>
			</v-menu>
		</v-app-bar>
        <v-row>
            
            <v-col cols="12" sm="12" md="5" lg="3">
                <v-card>
					<p style="font-size:25px;"> Cuentas Bancarias </p>
					<v-data-table
					:headers="headers"
					:items="data"
					:loading="loading"
					:items-per-page="10"
					class="elevation-1"
					item-class="my-custom-class"
				>
					<template v-slot:item.valor="{ item }">
						{{item.moneda}} {{item.valor}} 
                    </template>
					<template v-slot:item.etiqueta="{ item }">
						{{item.etiqueta}} {{item.alias}} 
                    </template>
					<template v-slot:item.retencion="{ item }">
						{{item.retencion}}%
                    </template>
					<template v-slot:item.action="{ item }">
						<v-icon
							@click="BuscarDatos(item)"
						>
							mdi-arrow-right-bold-circle-outline
						</v-icon>
                    </template>
				</v-data-table>
				</v-card>
				<vue-excel-xlsx
					v-if="cuenta != ''"
					:data="Estados"
					:columns="columns"
					:filename="'Reporte de Ventas '+$store.state.usuario.localidad"
					:sheetname="'Ventas'"
					>
					<v-btn color="accent"> Descargar Excel <v-icon large="">mdi-file-excel </v-icon> </v-btn>
				</vue-excel-xlsx> 
            </v-col>
            <v-col cols="12" sm="12" md="7" lg="9">    
				<v-row v-if="cuenta != ''">
					<v-col cols="12" lg="5" md="4" sm="12" xs="12">    
						<v-text-field filled v-model="search"  append-icon="mdi-magnify"
							:label="'Buscar en cuenta '+cuenta" single-line hide-details
						></v-text-field>
					</v-col>
					<v-col cols="12" lg="3" md="3" sm="5" xs="5">
						<v-text-field filled v-model="start" type="date" label="Fecha inicial"></v-text-field>
					</v-col>
					<v-col cols="12" lg="3" md="3" sm="5" xs="5">
						<v-text-field filled v-model="end"  type="date" label="Fecha final"></v-text-field>
					</v-col>
					<v-col cols="12" lg="1" md="1" sm="2" xs="1"> <v-btn :loading="loading" color="info" @click="listarFechas()" fab > <v-icon fab> mdi-cloud-search </v-icon> </v-btn>
					</v-col>
				</v-row>
                <v-data-table
                    :headers="headers2"
                    :items="Estados"
                    :search="search"
                    class="elevation-1"
					:loading="loading"
					item-class="my-custom-class"
                    >
					
                    <template v-slot:no-data>
                        <p> Seleccione una cuenta bancaria para ver el estado bancario </p>
                    </template>
                    <template v-slot:item.retencion="{ item }">
						{{item.retencion}} %
                    </template>
					<template v-slot:item.fechaRegistro="{ item }">
						{{item.fechaRegistro}} {{item.horaRegistro}}
                    </template>
                </v-data-table>
                
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import axios from 'axios'
import VueExcelXlsx from "vue-excel-xlsx";

//Vue.use(VueExcelXlsx);
  export default {
    data: () => ({
      
		dialog: false,
		data: [],
		Estados: [],
		headers: [
			{ text: 'Ver', value: 'action', sortable: false },
			{ text: 'Cuenta', value: 'etiqueta' },
			{ text: 'Saldo', value: 'valor' }, 
			{ text: 'Retención', value: 'retencion' },
		],
		headers2: [
			{ text: 'Registro', value: 'tipoRegistro' },
			{ text: 'Tipo Pago', value: 'tipoPago' },
			{ text: 'Crédito', value: 'ingreso' },
			{ text: 'Débito', value: 'egreso' }, 
			{ text: 'Saldo', value: 'montoSistema' },
			{ text: 'Doc', value: 'documento' },
			{ text: 'Fecha', value: 'fechaRegistro' },
			{ text: 'Usuario', value: 'usuario' },
			{ text: 'Cliente', value: 'persona' },
			{ text: 'Retención', value: 'retencion' },   
			{ text: 'Retenido', value: 'diferencia' },       
			{ text: 'Detalle', value: 'detalle' },    
		],
		columns : [
            { label: 'Registro', field: 'tipoRegistro' },
			{ label: 'Crédito', field: 'ingreso' },
			{ label: 'Débito', field: 'egreso' }, 
			{ label: 'Saldo', field: 'montoSistema' },
			{ label: 'Doc', field: 'documento' },
			{ label: 'Fecha', field: 'fechaRegistro' },
			{ label: 'Hora', field: 'horaRegistro' },
			{ label: 'Usuario', field: 'usuario' },
			{ label: 'Cliente', field: 'persona' },
			{ label: 'Retención', field: 'retencion' },   
			{ label: 'Retenido', field: 'diferencia' },       
			{ label: 'Detalle', field: 'detalle' },     
        ],
		search: '',
		links: [
			{ id: 1, name: "Transferencias", path: "/" },
			{ id: 2, name: "Depositos", path: "/about" },
		],
        editedIndex: -1,
		snackbar: true,
		dialog: false,
		tipoPago : 'EFECTIVO',
		TipoPagos:["TARJETA","EFECTIVO","TARJETA","DEPOSITO","SINPE"],
		loading: true,
		search: '',
		alias: '',
		cuenta:'',
		moneda:'',
		Mensaje :"Seleccione una cuenta",
		saldoinicial:0,
		detalle:'',
		dialogDeposito: false,
		Cuentas:[],
		retencion: 0,
		start: '',
		end: '',
    }),

    computed: {
      formTitle () {
			return this.editedIndex === -1 ? 'Nuevo Cliente' : 'Actualizar Cliente'
        },

    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      
    },

    created () {
      this.listar();
    },

    methods: {
		BuscarDatos (item) {
			let me=this;
			this.loading = true;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			axios.get('api/EstadoCuentas/'+this.$store.state.usuario.localidad+'/'+item.etiqueta,configuracion).then(function(response){
				//console.log(response);
				me.Estados=response.data;
				me.cuenta = item.etiqueta;
				me.loading = false;
				// me.modelCarga = false;
			}).catch(function(error){
				alert("Lo sentimos, Problema buscando información. Intenta de nuevo o comunique con su equipo de soporte este problema "+ error)
				console.log(error);
			});
      	},
		listarFechas () {
			let me=this;
			this.loading = true;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			axios.get('api/EstadoCuentas/GetFechas/'+this.$store.state.usuario.localidad+'/'+me.cuenta+'/'
			+this.start+'/'+this.end,configuracion).then(function(response){
				//console.log(response);
				me.Estados=response.data;
				me.loading = false;
				// me.modelCarga = false;
			}).catch(function(error){
				alert("Lo sentimos, Problema buscando información. Intenta de nuevo o comunique con su equipo de soporte este problema "+ error)
				console.log(error);
				me.loading = false;
				//location.reload();
			});
      	},
		CrearCuenta(){
			let me=this;
			this.loading = true;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			axios.post('api/EstadoCuentas',{
				'TipoRegistro':'Apertura Cuenta',
				'Ingreso':me.saldoinicial,
				'Egreso': 0,
				'Documento':'NA',
				'MontoSistema':me.saldoinicial,
				'Diferencia': 0,
				'Retencion': me.retencion,
				'detalle': me.detalle,
				'Tipo':me.alias,
				'Usuario':me.$store.state.usuario.nombre,
				'Localidad':me.$store.state.usuario.localidad, 
				'Persona': '',
				'TipoPago':'Apertura',
				'CuentaContable':me.cuenta,
				'Moneda':me.moneda, 
				'Estado':1,
				'EC_Estado':1,
				'IdEgreso':1,
			},configuracion).then(function(response){
					me.loading = false;
					me.dialog = false;
					me.listar();          
					me.limpiar();              
				}).catch(err => {
				me.loading =false;
				//console.log(err.response);
				alert("Error ingresando su cuenta, por favor intente de nuevo, si el problema persiste notifique a su equipo de soporte "+error)
			})
		},
		Deposito(){
			let me=this;
			this.loading = true;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			axios.post('api/EstadoCuentas/Deposito',{
				'TipoRegistro':'DEPOSITO',
				'Ingreso':me.saldoinicial,
				'Egreso': 0,
				'Documento':'DEPOSITO',
				'MontoSistema':me.saldoinicial,
				'detalle': me.detalle,
				'Usuario':me.$store.state.usuario.nombre,
				'Localidad':me.$store.state.usuario.localidad, 
				'Persona': '',
				'TipoPago':me.tipoPago,
				'Moneda':me.moneda,
				'CuentaContable':me.cuenta,
			},configuracion).then(function(response){
					me.loading = false;
					me.dialogDeposito = false;
					me.listar();          
					me.limpiar();              
					me.Mensaje = "Deposito realizado correctamente";
					me.snackbar = true;
					me.Estados = [];
				}).catch(err => {
				me.loading =false;
				//console.log(err.response);
				alert("Error ingresando su cuenta, por favor intente de nuevo, si el problema persiste notifique a su equipo de soporte "+error)
			})
		},
       	listar(){
			let me=this;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			axios.get('api/EstadoCuentas/ResumenCuentas/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				//console.log(response);
				me.data=response.data;
				me.loading = false;
				me.data.map(function(x){
					me.Cuentas.push({text: x.alias+ '-'+ x.etiqueta +' (' + x.valor + x.moneda + ')',value:x.etiqueta});
				});
				// me.modelCarga = false;
			}).catch(function(error){
				console.log(error);
			});
		},
		limpiar(){
			this.saldoinicial = 0;
			this.detalle = '',
			this.alias = '';
			this.cuenta = '';
			this.moneda = '';
		},

		close () {
			this.dialog = false;
			this.limpiar();
		},
    },
  }
</script>
<style>
	::v-deep .v-data-table tbody tr:nth-child(odd) {
	background-color: #f5f5f5; /*color de fondo para filas impares*/
	}

	::v-deep .v-data-table tbody tr:nth-child(even) {
	background-color: #ffffff; /*color de fondo para filas pares*/
	}
	::v-deep .my-custom-class tbody tr:nth-child(odd) {
	background-color: #f5f5f5; /*color de fondo para filas impares*/
	}

	::v-deep .my-custom-class tbody tr:nth-child(even) {
	background-color: #ffffff; /*color de fondo para filas pares*/
	}
</style>